var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSphereLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.333 48.165c.081 23.516 19.287 42.583 42.812 42.502 23.527-.08 42.603-19.278 42.522-42.794-.08-23.537-19.287-42.62-42.815-42.54-23.525.08-42.599 19.295-42.519 42.832zM47.867 9.363c-4.517.016-8.813.867-12.096 2.398-3.136 1.462-4.93 3.4-4.924 5.315.006 1.914 1.814 3.835 4.96 5.272 3.292 1.505 7.594 2.325 12.112 2.31 4.519-.016 8.816-.865 12.1-2.392 3.138-1.46 4.933-3.393 4.927-5.307-.006-1.915-1.816-3.84-4.964-5.281-3.295-1.508-7.597-2.33-12.115-2.315zm-21.042 7.029a38.527 38.527 0 0 0-12.043 13.037 38.013 38.013 0 0 0-4.857 18.723c.071 20.99 17.21 38.007 38.204 37.935 20.996-.072 38.018-17.207 37.947-38.196a38.01 38.01 0 0 0-4.983-18.687 38.488 38.488 0 0 0-12.127-12.948c.07.368.105.732.106 1.087.021 6.218-9.265 11.12-21.14 11.16-11.87.041-21.185-4.797-21.206-11.015a6.024 6.024 0 0 1 .1-1.096z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphereLoader);
export default __webpack_public_path__ + "static/media/sphere-loader.15e1a0f905f168645dee9fa07294cb71.svg";
export { ForwardRef as ReactComponent };